<template>
    <h1>Portfolio</h1>
</template>

<script>
export default {
    name: 'PortfolioComponent',
};
</script>

<style scoped>

</style>
